// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo__2S5BO","Logo_heading":"Logo_heading__2S5BO","Logo_desktop":"Logo_desktop__2S5BO","Logo_mobile":"Logo_mobile__2S5BO"};